import Script from "next/script";

const AhrefLoader = () => {
  return (
    <Script
      strategy="afterInteractive"
      src="https://analytics.ahrefs.com/analytics.js"
      data-key="en75GwB6wR+uLg6z+Cmc4w"
    />
  );
};

export default AhrefLoader;
